import { Status } from "./Status";

export class OuterCubeTypeSmartEnum {
    static Return = new Status("Return", 1, "pill-outlined pill-outlined--red");
    static Uplift = new Status("Uplift", 2, "pill-outlined pill-outlined--blue");

    // Allows for future support of standard pallets, e.g the BE franchise does not have
    // specific outer cube types, because they return to original location
    static Universal = new Status("Universal", 3, "pill--orange");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "OuterCubeTypeSmartEnum";
    }
}